export default {"src":"/_next/static/media/features-new-trending.7de1946b.gif","height":540,"width":800};